
export const ENTER_DOB = 'enter_dob'

export const MEDICAL_CHECK = 'medical_check'

export const RESCAN = 'rescan'

export const REFINEMENT_MEDICAL_CHECK = 'refinement_medical_check'

export const MEDICAL_CHECK_WITH_PRETREATMENT = 'medical_check_with_pretreatment'

export const MEDICAL_ASSESSMENT = 'medical_assessment'

export const CONFIRM_MEDICAL_CHECK = 'confirm_medical_check'

export const CONFIRM_REFINEMENT_MEDICAL_CHECK = 'confirm_refinement_medical_check'

export const CONFIRM_MEDICAL_CHECK_WITH_PRETREATMENT = 'confirm_medical_check_with_pretreatment'

export const CONFIRM_MEDICAL_ASSESSMENT = 'confirm_medical_assessment'

export const SELECT_REFINEMENT_TYPE = 'select_refinement_type'

export const VALIDATE_PRETREATMENT = 'validate_pretreatment'

export const SCAN_CUSTOMER = 'scan_customer'

export const TAKE_PICTURES = 'take_pictures'

export const UPLOAD_SCANS = 'upload_scans'

export const UPLOAD_SCAN_FILES_MANUALLY = 'upload_scan_files_manually'

export const CONSULT_CUSTOMER = 'consult_customer'

export const MATCH_3SHAPE = 'match_3shape'

export const IPR_CLEARING_UP = 'ipr_clearing_up'

export const IPR_EXPLANATION = 'ipr_explanation'

export const MANUAL_ADDRESS_CHECK = 'manual_address_check'

export const LOW_NPS_REASON = 'low_nps_reason';



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/in-shop-scan/task-name.js